import { Component, OnInit, HostListener } from '@angular/core';
import { MessageService } from 'primeng/api';
import { Router, ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-bikeshop-wizard',
  templateUrl: './bikeshop-wizard.component_2.html',
  styleUrls: ['./bikeshop-wizard.component_2.scss'],
  providers: [MessageService],
})
export class BikeshopWizardComponent implements OnInit {
  public showShadow = false;
  public step = -1;
  public verificationCode = null;
  public partner: any = {};
  public country = '';
  public region = 'your country';
  public showNotInRegion = false;

  constructor(
    public messageService: MessageService,
    public router: Router,
    public activatedRoute: ActivatedRoute,
    private http: HttpClient,
  ) {}

  ngOnInit() {
    this.http
      .get('https://api.db-ip.com/v2/free/self')
      .subscribe((res: any) => {
        this.country = res.countryCode;
        if (
          this.country == 'IN' ||
          this.country == 'PK' ||
          this.country == 'SD' ||
          this.country == 'RU' ||
          this.country == 'MY' ||
          this.country == 'SA' ||
          this.country == 'SO' ||
          this.country == 'DZ' ||
          this.country == 'NP' ||
          this.country == 'LS' ||
          this.country == 'MR' ||
          this.country == 'UA' ||
          this.country == 'YE' ||
          this.country == 'UG' ||
          this.country == 'KE'
        ) {
          this.showNotInRegion = true;
          this.region = res.countryName;
        } else {
          this.step = 1;
          this.activatedRoute.queryParams.subscribe((params) => {
            if (params['step'] === '2') {
              this.verificationCode = params['verificationCode'];
              this.step = 2;
            } else if (params['step'] === '3') {
              this.step = 3;
              this.verificationCode = params['verificationCode'];
            } else if (params['step'] === '4') {
              this.step = 4;
              this.verificationCode = params['verificationCode'];
            } else if (params['step'] === '5') {
              this.step = 5;
              this.verificationCode = params['verificationCode'];
            } else if (params['step'] === '6') {
              this.step = 6;
              this.verificationCode = params['verificationCode'];
            }
          });
        }
      });
  }

  @HostListener('window:scroll', ['$event'])
  onWindowScroll() {
    let pos =
      (document.documentElement.scrollTop || document.body.scrollTop) +
      document.documentElement.offsetHeight;
    let max = document.documentElement.scrollHeight;

    if (pos == max) {
      this.showShadow = false;
    } else {
      this.showShadow = true;
    }
  }

  home() {
    this.router.navigateByUrl('/');
  }

  next(data) {
    if (data && data.PartnerID) {
      this.partner = data;
    }
    this.step += 1;
    this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams: { step: this.step, verificationCode: this.verificationCode },
    });
  }

  goToStep(toStep) {
    if (this.step > toStep) {
      this.router.navigate([], {
        relativeTo: this.activatedRoute,
        queryParams: { step: toStep, verificationCode: this.verificationCode },
      });
    }
  }
}
